// Wrapper for uuid v4 (to support mocking during unit testing)
import { v4 } from "uuid";

export const uuidv4 = () => v4();
